import { CorpusId } from '../../../models/aliases';
import { events } from '../../../analytics/events';
import { useTrackedHandler } from '../../../hooks/useTracking';

import { Link } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import styled from 'styled-components';

interface LegalNoticeProps {
  corpusId: CorpusId;
  paperUrl: string;
}

export function LegalNotice(props: LegalNoticeProps): JSX.Element {
  const { corpusId, paperUrl } = props;

  const reportTrackingOnClick = useTrackedHandler(
    events.navigation.PaperLegalLinkClicked,
    (): void => {},
    () => ({ corpusId }),
  );

  return (
    <LegalNoticeSpan>
      Please visit the{' '}
      <Link
        href={paperUrl}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        onClick={reportTrackingOnClick}
      >
        source website
        <OpenInNewIcon />
      </Link>{' '}
      to access the full content.
    </LegalNoticeSpan>
  );
}

const LegalNoticeSpan = styled.span`
  margin-left: 2px;
  font-size: 14px;
  & .MuiSvgIcon-root {
    font-size: 12px;
    vertical-align: middle;
    margin: 0px 1px 0px 2px;
  }
`;
